import { Minus, Plus } from "lucide-react";
import { useId } from "react";
import { generationCount } from "@/lib/batches";

export function GenerationCount({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const id = useId();
  const count = generationCount(value);
  const invalid = count === null;
  const step = (delta: number) => onChange(String(Math.max(1, Math.min(Number.MAX_SAFE_INTEGER, count === null ? 1 : count + delta))));
  return <div className="flex flex-wrap items-center gap-2 text-xs text-studio-muted">
    <label htmlFor={id} className="font-semibold">Outputs</label>
    <div className="inline-flex items-center rounded-lg border border-studio-border bg-studio-panel">
      <button type="button" aria-label="Decrease outputs" disabled={count === 1} onClick={() => step(-1)}
        className="flex h-9 w-9 items-center justify-center rounded-l-lg hover:bg-studio-card disabled:opacity-40"><Minus className="h-3.5 w-3.5" /></button>
      <input id={id} aria-label="Generation count" type="text" inputMode="numeric" pattern="[0-9]*" value={value}
        onChange={(event) => onChange(event.target.value)} aria-invalid={invalid}
        aria-describedby={invalid ? `${id}-error` : undefined}
        onKeyDown={(event) => {
          if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            step(event.key === "ArrowUp" ? 1 : -1);
          }
        }}
        className="h-9 w-12 min-w-0 border-x border-studio-border bg-transparent text-center font-mono text-studio-ink" />
      <button type="button" aria-label="Increase outputs" disabled={count === Number.MAX_SAFE_INTEGER} onClick={() => step(1)}
        className="flex h-9 w-9 items-center justify-center rounded-r-lg hover:bg-studio-card disabled:opacity-40"><Plus className="h-3.5 w-3.5" /></button>
    </div>
    {invalid && <span id={`${id}-error`} role="alert">Enter a positive whole number.</span>}
  </div>;
}
